import api from "../utils/axios/axiosConfig";

const assignmentsService = {
  assign: (data) => api.post("/assignments/assign", data),
  unassign: (data) => api.patch("/assignments/unassign", data),
  reassign: (data) => api.post("/assignments/reassign", data),
  toggleActive: (id, data) => api.patch(`/assignments/${id}/toggle`, data),
  getManagerClients: (managerId, params) =>
    api.get(`/assignments/manager/${managerId}/clients`, { params }),
  getClientManagers: (clientId, params) =>
    api.get(`/assignments/client/${clientId}/managers`, { params }),
  search: (params) => api.post("/assignments/search", params),
  getOne: (id) => api.get(`/assignments/${id}`),
};

export default assignmentsService;
